import { render } from "./UnlockTopBrands.vue?vue&type=template&id=2de50da2"
import script from "./UnlockTopBrands.vue?vue&type=script&lang=js"
export * from "./UnlockTopBrands.vue?vue&type=script&lang=js"

import "./UnlockTopBrands.vue?vue&type=style&index=0&id=2de50da2&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__